import PropTypes from 'prop-types';
import ThreadItem, { threadItemShape, userShape } from './ThreadItem';

const ThreadsList = ({ threads, users }) => (
  <ul className="flex flex-col gap-6">
    {threads.map((thread) => (
      <ThreadItem
        {...thread}
        key={thread.id}
        owner={users.find((user) => user.id === thread.ownerId)}
      />
    ))}
  </ul>
);

ThreadsList.propTypes = {
  threads: PropTypes.arrayOf(PropTypes.shape(threadItemShape)).isRequired,
  users: PropTypes.arrayOf(PropTypes.shape(userShape)).isRequired,
};
export default ThreadsList;
